import React from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import ControllersDetails from "../views/Controllers/ControllersDetails";
import Telemetry from "../views/Controllers/Telemetry/telemetry";
import SensorDetails from "../views/Controllers/SensorDetails";
import DataExplorerPage from "../views/DataExplorer/DataExplorerPage";
import DashboardPage from "../views/Dashboard/DashboardPage";
import Calibration from "../views/Controllers/Calibration/Calibration";
import "./ControllerLayout.scss";

const ControllerLayout = () => {
  return (
    <Routes>
      <Route path={"*"} element={<Navigate to="/" />} />
      <Route path={"/"} element={<ControllersDetails />} />
      <Route path={"/telemetry"} element={<Telemetry />} />
      <Route path={"/data-explorer"} element={<DataExplorerPage />} />
      <Route path={"/calibrate"} element={<Calibration />} />
      <Route path={"/sensor/edit/:sensorId"} element={<SensorDetails />} />
      <Route path={"/snapshots/:dashboardId"} element={<DashboardPage />} />
    </Routes>
  );
};

export default ControllerLayout;
